import { FC, memo } from 'react';

import { SalesStatsData } from '@type-def_iqfu/public/MarketData';

import { PublicPropertyType } from '@constants_iqfu';

import styles from './TrendAverage.module.scss';

type Props = {
  displayData: SalesStatsData;
  areaName: string;
  propertyType: keyof typeof PublicPropertyType;
};

const AverageSalePeriodByDayLastYear: FC<Props> = memo(({ displayData, areaName, propertyType }) => {
  return (
    <>
      {displayData.average_sale_period_by_day_last_year?.year && (
        <div className={styles.container}>
          <div className={styles.trend_title}>
            {displayData.average_sale_period_by_day_last_year.year}年の{PublicPropertyType[propertyType]}
            <br />
            売却の平均成約期間（{areaName}）
          </div>

          <div className={styles.trend_value}>
            {displayData.average_sale_period_by_day_last_year.value.toLocaleString()}
            <span className={styles.unit_label}>日</span>
          </div>

          {/* 第一弾では非表示、ダッシュボード的な画面へリンクする */}
          {/* <Link href={`/`} prefetch={false} passHref>
          <a className={styles.trend_detail_link}>
            詳細データ
            <RightAow className={styles.right_arrow} />
          </a>
        </Link> */}
        </div>
      )}
    </>
  );
});

AverageSalePeriodByDayLastYear.displayName = 'AverageSalePeriodByDayLastYear';

export default AverageSalePeriodByDayLastYear;
